(() => {
  const root = document.querySelector('.techpod-blog-hub');
  if (!root) return;

  const tabs = [...root.querySelectorAll('[data-filter]')];
  const cards = [...root.querySelectorAll('.blog-card[data-lane]')];
  const searchForm = root.querySelector('[data-story-search-form]');
  const searchInput = root.querySelector('[data-story-search]');
  const emptyState = root.querySelector('[data-story-empty]');
  const loadMore = root.querySelector('[data-story-more]');
  const initialLimit = 12;
  let activeFilter = 'all';
  let expanded = false;
  let query = '';

  const cardMatchesFilter = (card) => {
    if (activeFilter === 'all') return true;
    if (activeFilter === 'community') return card.dataset.community === 'true';
    if (activeFilter === 'trending') return card.dataset.trending === 'true';
    return card.dataset.lane === activeFilter;
  };

  const cardMatchesSearch = (card) => {
    if (!query) return true;
    return (card.dataset.search || card.textContent || '').toLowerCase().includes(query);
  };

  const render = () => {
    const matching = cards.filter((card) => cardMatchesFilter(card) && cardMatchesSearch(card));

    cards.forEach((card) => {
      const matches = matching.includes(card);
      const withinLimit = query || expanded || activeFilter !== 'all' || matching.indexOf(card) < initialLimit;
      card.hidden = !(matches && withinLimit);
    });

    if (emptyState) emptyState.hidden = matching.length !== 0;

    if (loadMore) {
      const canExpand = !query && activeFilter === 'all' && matching.length > initialLimit && !expanded;
      loadMore.hidden = !canExpand;
    }
  };

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      activeFilter = tab.dataset.filter || 'all';
      expanded = false;
      tabs.forEach((item) => {
        const selected = item === tab;
        item.classList.toggle('is-active', selected);
        item.setAttribute('aria-pressed', String(selected));
      });
      render();
    });
  });

  searchForm?.addEventListener('submit', (event) => event.preventDefault());
  searchInput?.addEventListener('input', () => {
    query = searchInput.value.trim().toLowerCase();
    expanded = false;
    render();
  });
  searchInput?.addEventListener('search', () => {
    query = searchInput.value.trim().toLowerCase();
    expanded = false;
    render();
  });

  loadMore?.addEventListener('click', () => {
    expanded = true;
    render();
  });

  render();

  const loadOlderStories = async () => {
    let nextLink = root.querySelector('[data-story-next]');
    const grid = root.querySelector('#blog-story-grid');
    const loadedPages = new Set();
    while (nextLink && grid) {
      const nextUrl = new URL(nextLink.getAttribute('href'), window.location.href);
      if (nextUrl.origin !== window.location.origin || loadedPages.has(nextUrl.href)) break;
      loadedPages.add(nextUrl.href);
      nextLink.hidden = true;
      try {
        const response = await fetch(nextUrl.href, {credentials: 'same-origin'});
        if (!response.ok) throw new Error('Unable to load older stories');
        const documentPage = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextGrid = documentPage.querySelector('#blog-story-grid');
        if (!nextGrid) throw new Error('Missing stories');
        const existingUrls = new Set(cards.map(card => card.querySelector('.card-poster')?.getAttribute('href')));
        for (const card of nextGrid.querySelectorAll('.blog-card[data-lane][data-published-at]')) {
          const href = card.querySelector('.card-poster')?.getAttribute('href');
          if (!href || existingUrls.has(href)) continue;
          existingUrls.add(href);
          grid.appendChild(card);
          cards.push(card);
        }
        nextLink.remove();
        nextLink = nextGrid.querySelector('[data-story-next]');
        if (nextLink) grid.appendChild(nextLink);
        render();
      } catch {
        nextLink.hidden = false;
        break;
      }
    }
    root.dataset.storyIndexReady = nextLink ? 'partial' : 'complete';
  };
  loadOlderStories();
})();




